import React, { useState } from 'react';
import {
  CustomModal,
  getTranslatedText,
  SaveCard,
  Loader,
  toast,
  EventEmitter
} from '@nile/components';
import { AccountClient } from '@nile/graphql';
import { DisplayText, Page, RadioButton } from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import {
  GET_GROWTH_REPORT_CONFIGURATION,
  UPDATE_GROWTH_REPORT_CONFIG
} from '@nile/reports/src/modules/EfficiencyReport/graphql';
import { GROWTH_CONFIG_CHOICES } from '@nile/reports/src/modules/reports/constants';

function GrowthReportConfig(props) {
  const { callBack } = props;
  const intl = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const { loading: metaLoading } = useQuery(GET_GROWTH_REPORT_CONFIGURATION, {
    fetchPolicy: 'network-only',
    client: AccountClient,
    onCompleted(res) {
      setSelectedOption(res?.getReportCalculationStatus);
    }
  });

  const handleSave = () => {
    setIsLoading(true);
    AccountClient.mutate({
      mutation: UPDATE_GROWTH_REPORT_CONFIG,
      variables: { input: { status: selectedOption } }
    })
      .then((res) => {
        if (res?.data?.updateReportCalculationStatus) {
          toast('success', 'admin.eventTrigger.configUpdate.success');
          setIsLoading(false);
          EventEmitter.dispatch('refreshProfitabilityReport');
          if (callBack) {
            callBack();
          }
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <CustomModal open locked onClose={callBack}>
      <Page
        variant="primary"
        title={getTranslatedText(intl, 'common.label.configure')}
        primaryAction={
          <SaveCard
            removeSecondaryBtnBg
            handleSave={handleSave}
            actions={{ back: callBack }}
            loading={isLoading}
          />
        }
      >
        <div className="vh-set-banner w900">
          {metaLoading ? (
            <Loader />
          ) : (
            <>
              <div className="mb20">
                <div className="fx">
                  <div className="f11">
                    <div className="mb20">
                      <DisplayText element="h3" weight="SemiBold">
                        <FormattedMessage id="msp.reports.profitablity.config.calculation.header" />
                      </DisplayText>
                    </div>
                    {GROWTH_CONFIG_CHOICES?.map((el) => (
                      <div className="mb6">
                        <RadioButton
                          label={getTranslatedText(intl, el?.choice?.title)}
                          helpText={getTranslatedText(
                            intl,
                            el?.choice?.description
                          )}
                          checked={selectedOption === el?.name}
                          onChange={() => setSelectedOption(el?.name)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Page>
    </CustomModal>
  );
}

export default GrowthReportConfig;
